import React, { useMemo } from 'react';
import styled from "styled-components";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useDispatch, useSelector } from "react-redux";
import {
  MeetingRoomBookingViewPanel,
  selectOrderedHospitalityMenuItems,
  selectSpecialHospitalityItems,
  setDialogPanel,
  setOrderedHospitalityMenuItems,
  setSpecialItems
} from "../../models/meeting-room-booking-dialog.duck";
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import {
  HospitalityOrderItem,
  HospitalityOrderItemWithQuantity,
  SpecialHospitalityItem
} from "../../models/hospitality.models";
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { DeliverySelection } from "./DeliverySelection";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function MeetingRoomBookingTabHospitalityView(props: Props) {
  const dispatch = useDispatch();
  const specialItems = useSelector(selectSpecialHospitalityItems);
  const orderedHospitalityMenuItems = useSelector(selectOrderedHospitalityMenuItems);

  const menuItemsWithQuantities = useMemo(() => {
    return orderedHospitalityMenuItems.filter(m => m.quantity > 0);
  }, [orderedHospitalityMenuItems]);

  const onAddItemsFromMenuClicked = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.AddItemsFromMenu));
  }

  const onAddInstructionsClicked = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.AddInstructions));
  }

  const onAddSpecialItems = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.AddSpecialItems));
  }

  const removeSpecialItem = (item: SpecialHospitalityItem) => {
    dispatch(setSpecialItems([...specialItems.filter(si => si.id !== item.id)]))
  }

  const removeOrderItem = (item: HospitalityOrderItem) => {
    dispatch(setOrderedHospitalityMenuItems([...orderedHospitalityMenuItems.filter(si => si.id !== item.id)]))

  }

  return (
    <Container>
      <MenuList>
        <DeliverySelection userCanSaveBooking={props.userCanSaveBooking} />
        <Header>
          <BodySmall className={'hospitalityList__itemLabel'} weight={600} colour={Colours.darkGrey}>Item</BodySmall>
          <BodySmall className={'hospitalityList__itemQuantity'} style={{marginRight: 32}} weight={600} colour={Colours.darkGrey}>Quantity</BodySmall>
        </Header>
        {specialItems.map((item: SpecialHospitalityItem, key: number) => <Row key={key}>
          <BodySmall className={'hospitalityList__itemLabel'}>{item.description}</BodySmall>
          <BodySmall className={'hospitalityList__itemQuantity'}>{item.quantity}</BodySmall>
          <IconButton icon={IconTypes.Bin} onClick={() => removeSpecialItem(item)} disabled={!props.userCanSaveBooking} />
        </Row>)}
        {menuItemsWithQuantities.map((item: HospitalityOrderItemWithQuantity, key: number) => <Row key={key}>
          <BodySmall className={'hospitalityList__itemLabel'}>{item.label}</BodySmall>
          <BodySmall className={'hospitalityList__itemQuantity'}>{item.quantity}</BodySmall>
          <IconButton icon={IconTypes.Bin} onClick={() => removeOrderItem(item)} disabled={!props.userCanSaveBooking} />
        </Row>)}
      </MenuList>
      <Controls>
        <OutlineButton click={onAddItemsFromMenuClicked}
                       text={'hospitality.add-from-menu'}
                       disabled={!props.userCanSaveBooking}
                       size={ButtonSize.Small} />
        <OutlineButton click={onAddInstructionsClicked}
                       disabled={!props.userCanSaveBooking}
                       text={'hospitality.add-instructions'}
                       size={ButtonSize.Small} />
        <OutlineButton click={onAddSpecialItems}
                       disabled={!props.userCanSaveBooking}
                       text={'hospitality.add-special-items'}
                       size={ButtonSize.Small} />
      </Controls>
    </Container>
  )
}

interface Props {
  userCanSaveBooking: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const MenuList = styled.div`
  height: 280px;
  overflow-y: auto;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  .hospitalityList__itemLabel {
    width: 80%;
  }
  .hospitalityList__itemQuantity {
    width: 20%;
    text-align: center;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${Colours.lightGrey};
  .hospitalityList__itemLabel {
    width: 80%;
    margin-left: 8px;
  }
  .hospitalityList__itemQuantity {
    width: 20%;
    text-align: center;
  }
`

const Controls = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 12px;
  button:first-child {
     margin-right: 8px;
  }
  button:last-child {
     margin-left: 8px;
  }
`
